import { render, staticRenderFns } from "./TeacherExtras.vue?vue&type=template&id=e88f9aac&scoped=true"
import script from "./TeacherExtras.vue?vue&type=script&lang=js"
export * from "./TeacherExtras.vue?vue&type=script&lang=js"
import style0 from "./TeacherExtras.vue?vue&type=style&index=0&id=e88f9aac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e88f9aac",
  null
  
)

export default component.exports